import { render, staticRenderFns } from "./CookiesAdvice.vue?vue&type=template&id=fe0c7a42"
import script from "./CookiesAdvice.vue?vue&type=script&lang=js"
export * from "./CookiesAdvice.vue?vue&type=script&lang=js"
import style0 from "./CookiesAdvice.vue?vue&type=style&index=0&id=fe0c7a42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports